export const mutations = {
    PRICING_SET_IS_LOGGED_IN(state, payload) {
        state.isLoggedIn = payload;
    },
    /* team signup */
    PRICING_SET_TEAM_STEP1(state, payload) {
        state.teamStep1 = {...state.teamStep1, ...payload};
    },
    PRICING_SET_TEAM_STEP2(state, payload) {
        state.teamStep2 = {...state.teamStep2, ...payload};
    },
};
